export enum ROOT_MENU_ENUM {
  HOME = '/home',
  INVENTORY = '/inventory',
  SALES = '/sales',
  CRM = '/crm',
  CMS = '/cms',
  SECURITY = '/security',
  REPORTS = '/reports',
  SETTINGS = '/settings',
  CONCILIATION = '/conciliation',
}
